import { render, staticRenderFns } from "./isiLoker.vue?vue&type=template&id=2ff28a68&"
import script from "./isiLoker.vue?vue&type=script&lang=js&"
export * from "./isiLoker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports